import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ErrorType } from 'src/app/enums/enums.enum';
import { Globals } from 'src/app/globals';
import { ErrorModel } from 'src/app/models/error-model';
import { CustomErrorHandler } from 'src/app/services/error-handler.service';
import { TokenizationService } from 'src/app/services/tokenization.service';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent {
  currentError$: Observable<ErrorModel>;


  constructor(
    private errorHandler: CustomErrorHandler,
    private tokenization: TokenizationService,
    private router: Router,
  ) { }

  ngOnInit() {
    // First check if there are any errors in the log
    const errorLog = this.errorHandler.getErrorLog();
    if (errorLog.length === 0) {
      // No errors in the log, create a default error
      const defaultError = new Error();
      Object.assign(defaultError, {
        status_code: "S00",
        user_message_title: "Ha ocurrido un error",
        user_message_desc: "No se pudo completar la operación. Por favor, intente nuevamente más tarde.",
        data: {
          retry: "true"
        }
      });

      this.errorHandler.reportError(defaultError, ErrorType.UNKNOWN);
    }

    // Now we can subscribe to the errors$ stream which will have at least our mock error
    this.currentError$ = this.errorHandler.errors$;
    /* test */
    // const mockError = new Error();
    // Object.assign(mockError, {
    //   status_code: 200,
    //   data: {
    //     user_message_title: "Texto de ejemplo",
    //     user_message_desc: "No deberías ver esto",
    //     retry: "true"
    //   }
    // });
    // this.errorHandler.reportError(mockError, ErrorType.AUTH);
    /* --- */
  }

  submitGoHomeApp(errorAppUrl: string) {
    Globals.manuallyNavigateTo(errorAppUrl);
  }

  submitRetry() {
    if (this.tokenization.medioPagoId) {
      this.router.navigate(['/'], { queryParams: { id: this.tokenization.medioPagoId } });
    } else {
      this.router.navigate(['/']); // redirige acá con error
    }
  }

}
